import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IconButton } from '@mui/material'

type DataTableOpenPanelButtonProps = {
    accessibleLabel: string
    onClick: () => void
    disabled?: boolean
}

export const DataTableOpenPanelButton = ({
    accessibleLabel,
    onClick,
    disabled = false,
}: DataTableOpenPanelButtonProps) => (
    <IconButton
        aria-label={accessibleLabel}
        disabled={disabled}
        onClick={(event) => {
            event.stopPropagation()
            onClick()
        }}
        sx={{ p: 1, color: 'figma.primary', '&.Mui-disabled': { color: 'figma.grayscale.tier4' } }}
    >
        <ArrowForwardIosIcon fontSize="small" color="inherit" />
    </IconButton>
)

export default DataTableOpenPanelButton
